@if (error) {
  <section class="error-page-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="error-content">
            <h2 data-translation-key="error_pages_somthing_went_wrong">
              {{ 'error_pages.somthing_went_wrong' | translate }}
            </h2>
            <p>
              {{ error.message | translate }}
            </p>
            <div class="error-details">
              <div class="error-code">
                <span>{{ error.statusCode }}</span>
              </div>
              <div class="error-message">
                <h4>{{ getErrorTitle() | translate }}</h4>
                <p>{{ error.statusText }}</p>
              </div>
            </div>

            <!-- Dev Details Section (only in development mode) -->
            @if (isDev && error.devDetails) {
              <div class="dev-details-section">
                <button
                  type="button"
                  class="btn btn-dev-toggle"
                  (click)="toggleDevDetails()"
                >
                  <i class="bi" [class.bi-chevron-down]="!showDevDetails" [class.bi-chevron-up]="showDevDetails"></i>
                  {{ 'error_inline.dev_details' | translate }}
                </button>
                @if (showDevDetails) {
                  <div class="dev-details-content">
                    @if (error.devDetails.url) {
                      <div class="dev-detail-item">
                        <strong>URL:</strong>
                        <code>{{ error.devDetails.url }}</code>
                      </div>
                    }
                    <div class="dev-detail-item">
                      <strong>Status:</strong>
                      <code>{{ error.statusCode }} {{ error.statusText }}</code>
                    </div>
                    @if (error.devDetails.timestamp) {
                      <div class="dev-detail-item">
                        <strong>Timestamp:</strong>
                        <code>{{ error.devDetails.timestamp | date:'medium' }}</code>
                      </div>
                    }
                    @if (error.devDetails.error) {
                      <div class="dev-detail-item">
                        <strong>Response:</strong>
                        <pre class="error-json">{{ formatDevDetails() }}</pre>
                      </div>
                    }
                  </div>
                }
              </div>
            }

            <div class="error-actions">
              @if (!isSeller) {
                <a
                  (click)="navigateToLandingPage()"
                  class="btn btn-primary"
                >
                  <i
                    class="bi bi-house-door"
                    data-translation-key="error_pages_go_homepage"
                  ></i>
                  {{ 'error_pages.go_homepage' | translate }}
                </a>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
}
